import React from 'react';
import { translate } from 'react-i18next';

import Form from './Form';
import * as API from '../../core/api';
import { catchFormErrors } from '../../utils/form-errors';

class Edit extends React.Component {
  handleSubmit = (formValues) => {
    const { onSuccess } = this.props;

    const promises = [];
    promises.push(
      API.put('users/me/', {
        ...formValues,
        urls: formValues.urls
          ? formValues.urls.split(',').map((url) => url.trim())
          : [],
      })
    );

    const isNewAvatarSelected = typeof formValues.avatarUrl === 'object';
    if (isNewAvatarSelected) {
      const data = new FormData();
      data.append('avatar', formValues.avatarUrl, formValues.avatarUrl.name);

      promises.push(API.post('users/me/avatar', data));
    }

    return Promise.all(promises)
      .then(onSuccess)
      .catch(catchFormErrors);
  };

  render() {
    const { user, t } = this.props;

    return (
      <Form
        initialValues={{ ...user, urls: user.urls.join(', ') }}
        okButtonText={t('general.saveChanges')}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default translate()(Edit);



// WEBPACK FOOTER //
// ./src/user/edit/index.js